/**
 * Displays the top section of an employer profile page,
 * includes background, logo, companyTitle and meta content
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';

class ProfileHeader extends Component {
    static propTypes = {
        style: PropTypes.object,
        backgroundImgComponent: PropTypes.object,
    };

    render() {
        const { style } = this.props;

        return (
            <section
                className="profile panel panel--neutral u-mh0 profilebg profile-header u-mb32"
                style={style}
            >
                {this.props.backgroundImgComponent}
            </section>
        );
    }
}

export default ProfileHeader;
